<template>
  <input 
    :value="value"
    :class="[style.input, error ? style.inputError : '']"
    :type="type" 
    :placeholder="placeholder" 
    @input="$emit('input', $event.target.value)"
  >
</template>

<script>
import style from './style.module.scss'

export default {
  name: 'Input',
  components: {
    
  },
  props: {
    value: {
      type: String,
      default: '',
      required: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: false,
      default: "text"
    },
    placeholder: {
      type: String,
      required: false,
      default: "Поле ввода"
    }
  },
  data() {
    return {
      style: style
    }
  },
}
</script>